import React, { useState } from 'react';
import configuration from '../config/configuration.json';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const theme = createTheme({
  palette: {
    primary: {
      main: '#19513c'
    },
    secondary: {
      main: '#ff9900'
    },
  },
});

const WorkWithUs = () => {
	const [name, setName] = useState(null);
	const [lastName, setLastName] = useState(null);
	const [email, setEmail] = useState(null);
	const [file, setFile] = useState(null);
	const [captchaValidation, setCaptchaValidation] = useState(false);
	const [interests, setInterests] = useState("");
	const [errors, setErrors] = useState("");
	const [open, setOpen] = useState(false);
	const [checking, setChecking] = useState(false);
	const [options, setOptions] = useState(
		{
			'comercial': false,
			'administrativa': false,
			'contabilidad': false,
			'ganaderia': false
		}
	);

	let captcha;

	function openDialog() {
		setOpen(true);
	}

	function closeDialogWindow() {
		setEmail("");
		setName("");
		setLastName("");
		setFile(null);

		Object.keys(options).map(option => {
			options[option] = false
		});

		resetCaptcha();
		setOpen(false);
		setChecking(false);
	}

	const setCaptchaRef = (ref) => {
		if(ref) {
			return captcha = ref;
		}
	}

	function togglePreference(value) {
		let checkBoxClick = options;
		checkBoxClick[value] = !options[value];
		setOptions(checkBoxClick);

		var interestChecked = Object.keys(checkBoxClick).filter(k => { return checkBoxClick[k] ? k : '' });
		let interestData = "";
		interestData += interestChecked + " ";
		setInterests(interestData.trim());
	}

	const resetCaptcha = () => {
		captcha.reset();
	}

	const handleFile = (e) => {
		setFile(e.target.files[0]);
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		setChecking(true);
		setErrors([]);

		const formData = new FormData();
		const formDataBD = new FormData();

		let ignore = false;
		let errorArray = [];
		let countFalse = 0;
		let contentData = [];

		Object.keys(options).map(option => {
			if(options[option] === false) {
				countFalse++;
			}
		});

		if(countFalse >= 4) {
			errorArray.push("Debes chequear al menos una opción de interés");
			setChecking(false);
		}

		if(name === null || name === "") {
		 errorArray.push("El nombre es necesario.");
		 setChecking(false);
		}
		if(lastName === null || lastName === "") {
			errorArray.push("El apellido es necesario.");
			setChecking(false);
		}

		if(email === null || email === "") {
			errorArray.push("El correo electrónico es necesario.");
			setChecking(false);
		}

		if(file === null || file === "") {
		 errorArray.push("El archivo CV es necesario.");
		 setChecking(false);
		}

		if(!captchaValidation) {
			errorArray.push("La validación del captcha es necesario.");
			setChecking(false);
		}

		if(errorArray.length > 0) {
			setErrors(errorArray);
		}

		else {
			contentData = [
				{ "key": "Nombre", "value": name },
				{ "key": "Apellido", "value": lastName },
				{ "key": "Correo electrónico", "value": email },
				{ "key": "Intereses", "value": interests },
			]

			//formData content for DB table form and send email
			formData.append("subject", "Trabaja con nosotros");
			formData.append("content", JSON.stringify(contentData));
			formData.append("isForEmail", true);
			formData.append("toEmail", "web-trabajemosjuntos@elrodeo.com.py");
			formData.append("formType", "Trabaja_con_nosotros");
			formData.append("files", [file]);

			//formData content for DB table workwithus
			formDataBD.append("name", name);
			formDataBD.append("lastName", lastName);
			formDataBD.append("mail", email);
			formDataBD.append("text", "N/A");
			formDataBD.append("interests", interests);
			formDataBD.append("resume", file);

			//Save on the DB table forms and send email.
			axios.post(configuration.PANEL_SERVER_URL + configuration.POST_SUBMIT_FORM, formData)
				.then((response) => {
					if (!ignore) {
						if(response.data.status == "error") {
							setChecking(false);
						}

						if(response.data.status == "Ok") {
							setChecking(false);
							openDialog();
						}
					}
				})
				.catch((error) => {
					if(error.name === "AxiosError") {
						errorArray.push("Ocurrió un error al enviar el formulario.");
						setErrors(errorArray);
						setChecking(false);
					}
				})
				.then(() => {
					ignore = true;
					//Save on the DB table
					axios.post(configuration.PANEL_SERVER_URL + configuration.POST_WORK_WITH_US, formDataBD)
						.catch((error) => {
							if(error.name === "AxiosError") {
								errorArray.push("Ocurrió un error al guardar el formulario.");
								setErrors(errorArray);
								setChecking(false);
							}
						})
						.then(() => {
							ignore = true;
					})
			})

		}
	}

	function onChangeRecaptcha(value) {
		if(value === null) {
			setCaptchaValidation(false);
		}
		else {
			setCaptchaValidation(true);
		}
	}

	return (
		<div className="general-banner-container bg-white">
			<img className="inst-banner" src={ require('../img/banners/trabaja_con_nosotros.png') } />
			<div className="properties-container">

				{ errors.length > 0 ?
					<ul
						style={{
							backgroundColor: "#ff000033",
							listStyle: 'none',
							padding: '17px',
							borderRadius: '8px',
							marginBottom: '1rem'
						}}
						>
						{ Object.values(errors).map(error => (
							<li>{ error }</li>
						))}
					</ul>
					: null
				}

				<ThemeProvider theme={theme}>
					<Box
						component="form"
						onSubmit={(e) => { handleSubmit(e) }}
						autoComplete="off"
						>

						<TextField
							className="input-newsletter"
							color={`primary`}
							required
							fullWidth id="outlined-basic"
							value={ name || "" }
							onChange={(e) => { setName(e.target.value) }}
							label="Nombre" variant="standard" />

						<TextField className="input-newsletter"
							fullWidth
							required
							id="outlined-basic"
							label="Apellido"
							value={ lastName || "" }
							onChange={(e) => { setLastName(e.target.value) }}
							variant="standard" />

						<TextField
							className="input-newsletter"
							type="mail"
							required
							fullWidth
							id="outlined-basic"
							label="Correo Electrónico"
							value={ email || "" }
							onChange={(e) => { setEmail(e.target.value) }}
							variant="standard" />

						<div className="mt-2 mb-2">
							<p style={{ marginBottom: '10px' }}>Subir mi C.V</p>
							<Button variant="contained" component="label">
								Subir archivo
								<input
									hidden
									accept=".doc, .pdf"
									onChange={ (e) => handleFile(e) }
									type="file" />
							</Button>
						</div>

						<FormGroup className="select-group-newsletter">
							<p>Secciones de interés: </p>
							<FormControlLabel
								value="comercial"
								onChange={(e) => togglePreference(e.target.value)}
								control={<Checkbox checked={ options['comercial'] ? true : false }/>}
								label="Area Comercial" />
							<FormControlLabel
								value="administrativa"
								onChange={(e) => togglePreference(e.target.value)}
								control={<Checkbox checked={ options['administrativa'] ? true : false }/>}
								label="Area Administrativa" />

							<FormControlLabel
								value="contabilidad"
								onChange={(e) => togglePreference(e.target.value)}
								control={<Checkbox checked={ options['contabilidad'] ? true : false }/>}
								label="Area de Contabilidad" />

							<FormControlLabel
								value="ganaderia"
								onChange={(e) => togglePreference(e.target.value)}
								control={<Checkbox checked={ options['ganaderia'] ? true : false }/>}
								label="Area de Ganaderia" />
						</FormGroup>

						<div style={{ marginTop: '1.3rem' }}>
							<ReCAPTCHA
								ref={ (r) => setCaptchaRef(r) }
								sitekey="6LcmvCIkAAAAAAY9wLH-OCvLuZ8kIEl6PkcV4BaO"
								onChange={onChangeRecaptcha}
								/>
						</div>

						<div className="align-center">
							<button
								className="button-submit"
								disabled={ checking ? true : false }
								type="submit">{ checking ? "Enviando..." : "Enviar" }</button>
						</div>
					</Box>
				</ThemeProvider>
			</div>

			<Dialog
				open={open}
				onClose={closeDialogWindow}
				aria-labelledby="success-dialog-title"
				aria-describedby="success-dialog-description"
				>

				<DialogTitle className="dialogTitle" id="alert-dialog-title">
					{ "Confirmación de envío" }
				</DialogTitle>
				<DialogContent style={{ paddingBottom: 0 }}>
					<DialogContentText id="alert-dialog-description" className="alert-dialog-description">
						Muchas gracias por tu interés en trabajar con nosotros, nos pondremos en contacto contigo en la brevedad.
					</DialogContentText>
				</DialogContent>

				<DialogActions className="dialogActionWrapper">
					<Button className="dialogBtn submitDialogButton" onClick={closeDialogWindow} autoFocus>
						Aceptar
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default WorkWithUs;
